import axios from 'axios'
import CryptoJS from 'crypto-js/crypto-js'
import { Message } from 'element-ui'
import store from '../store'

// 创建axios实例
const service = axios.create({
    baseURL: store.getters.baseUrl,
    timeout: 15000 // 请求超时时间
})

// 生产sign的密钥
var SECRET = process.env.SCREAT
// url必须携带的验证参数key
var signKey = process.env.KEY

/**
 * request拦截器
 * */
service.interceptors.request.use(config => {
    if (config.timeout !== undefined) {
        service.defaults.timeout = config.timeout
    } else {
        service.defaults.timeout = 15000
    }
    config.url = authFormat(config)
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

/**
 * respone拦截器
 * */
service.interceptors.response.use(response => {
    const res = response.data
    // 重置页面登录标记时间
    localStorage.setItem("dq_center_li_time",new Date().getTime());
    // 请求失败
    if (res.code !== 200) {
        Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject('error')
    }
    // 请求成功
    else {
        return response.data
    }
}, error => {
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
    })
    return Promise.reject(error)
}
)

/**
 * 生产sign,拼接该次请求最终url和参数
 * @param {*} config
 */
var authFormat = (config) => {
    var type = 'admin'
	if (config.type) {
		type = config.type
    }
    var url = "/"+ type +"/"
    if(type == 'app'){
        url += "v1.0/"
        signKey = process.env.APP_KEY
		SECRET = process.env.APP_SCREAT
    }
    url += config.module + config.url
    var timestamp = new Date().getTime()
    url += url.indexOf("?") == -1 ? ("?token=" + sessionStorage.getItem('token')) : ("&token=" + sessionStorage.getItem('token'))
    url += "&timestamp=" + timestamp
    url += "&key=" + (signKey ? signKey : "")
    var requestURI = url.split("?")[0]
    requestURI = url.startsWith("/") ? requestURI : "/" + requestURI
    requestURI = url.endsWith("/") ? requestURI.substring(0, requestURI.length - 1) : requestURI
    // 请求参数
    var args = new Array()
    var query = url.split("?")[1]
    var pairs = query.split("&")
    for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('=')
        if (pos == -1) continue
        var argname = pairs[i].substring(0, pos)
        var value = pairs[i].substring(pos + 1)
        value = decodeURIComponent(value)
        var arg = new Object()
        arg.key = argname
        arg.value = value
        args.push(arg)
    }
    args = args.sort(function (a, b) {
        return a.key > b.key ? 1 : -1
    })
    var paramstring = ""
    for (var index in args) {
        paramstring += args[index].key + args[index].value
    }
    // 非get方法的body添加
    var body = ""
    if ("get" != config.method.toLowerCase() && config.data) {
        body = JSON.stringify(config.data)
    }
    var sign = CryptoJS.HmacMD5(requestURI + paramstring + body, SECRET)
    url = url + "&sign=" + sign
    return url
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js